import { useFrame } from "react-frame-component";

// returns the document and window of the frame if it exists, otherwise the main document and window
// and a boolean indicating if the current component is inside a frame
export const useFrameDocument = () => {
  const { document: frameDocument, window: frameWindow } = useFrame();
  const targetDocument: Document = frameDocument || document;
  const targetWindow: Window = frameWindow ?? window;
  const isInFrame = frameDocument && frameDocument !== document;
  return {
    frameDocument: targetDocument,
    frameWindow: targetWindow,
    isInFrame,
  };
};
